export default "__VITE_ASSET__4ff2dd66__"